export enum FormControls {
  UserFirstName = 'userFirstName',
  UserLastName = 'userLastName',
  UserEmail = 'userEmail',
  UserPhone = 'userPhone',
  Prefix = 'prefix',
  RulesConsent = 'rulesConsent',
  SmsConsent = 'smsConsent',
  EmailConsent = 'emailConsent',
  CheckAll = 'checkAll',
  VoucherNumber = 'voucherNumber',
  TaxId = 'taxId',
}

export enum SignUpFormControls {
  FirstName = 'firstName',
  LastName = 'lastName',
  Email = 'email',
  PhoneNumber = 'phoneNumber',
  PhoneNumberCountryCode = 'phoneNumberCountryCode',
  Nip = 'nip',
  Password = 'password',
  RepeatPassword = 'repeatPassword',
  BirthDay = 'birthDay',
  BirthMonth = 'birthMonth',
  BirthYear = 'birthYear',
  MarketingConsent = 'marketingConsent',
  SmsConsent = 'smsConsent',
  RulesConsent = 'rulesConsent',
  BasicRulesConsent = 'basicRulesConsent',
}

export enum SignInFormControls {
  Email = 'email',
  Password = 'password',
}

export enum PasswordResetFormControls {
  Email = 'email',
  Password = 'newPassword',
  RepeatPassword = 'newPasswordConfirmation',
}
